if (!customElements.get('mandl-product-slider')) {
  customElements.define(
    'mandl-product-slider',
    class MandlProductSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mandl-strip__slider');
        // Arrows live in the sibling header — search the shared parent container
        const container = this.closest('.page-width') || this.parentElement;
        this.prevBtn = container?.querySelector('.mandl-strip__arrow--prev');
        this.nextBtn = container?.querySelector('.mandl-strip__arrow--next');

        if (!this.track) return;

        this.prevBtn?.addEventListener('click', () => this.advance(-1));
        this.nextBtn?.addEventListener('click', () => this.advance(1));

        // Both arrows always enabled — we loop at boundaries
        if (this.prevBtn) this.prevBtn.disabled = false;
        if (this.nextBtn) this.nextBtn.disabled = false;
      }

      advance(direction) {
        const firstCard = this.track.querySelector('.mandl-strip__card');
        if (!firstCard) return;

        // Card width + gap = one scroll step
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const cardWidth = firstCard.offsetWidth + gap;

        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const maxScroll = scrollWidth - clientWidth;

        if (direction > 0) {
          // Next: loop back to start when at end
          if (scrollLeft >= maxScroll - 2) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.track.scrollBy({ left: cardWidth, behavior: 'smooth' });
          }
        } else {
          // Prev: loop to end when at start
          if (scrollLeft <= 2) {
            this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          } else {
            this.track.scrollBy({ left: -cardWidth, behavior: 'smooth' });
          }
        }
      }
    }
  );
}
